<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
        <div class="section-1400 pt-xl-4">
            <div class="container-fluid padding-top-40">
                <div class="row justify-content-center">
                    <img src="assets/img/genbd.png" alt="General Body Meeting coming soon"
                         style="max-width: 800px; margin-bottom: 20px;">


                </div>
            </div>
        </div>
    </div>
</div>
